import $ from 'jquery';

$.extend($.fn.dataTableExt.oSort, {
    'datetime-asc': function(a, b) {
        let x, y;
        if ($.trim(a) !== '') {
            const deDatea = $.trim(a).split(' ');
            const deTimea = deDatea[1].split(':');
            const deDatea2 = deDatea[0].split('.');
            if (typeof deTimea[2] !== 'undefined') {
                x =
                    (deDatea2[2] +
                        deDatea2[1] +
                        deDatea2[0] +
                        deTimea[0] +
                        deTimea[1] +
                        deTimea[2]) *
                    1;
            } else {
                x =
                    (deDatea2[2] +
                        deDatea2[1] +
                        deDatea2[0] +
                        deTimea[0] +
                        deTimea[1]) *
                    1;
            }
        } else {
            x = -Infinity; // = l'an 1000 ...
        }

        if ($.trim(b) !== '') {
            let deDateb = $.trim(b).split(' ');
            const deTimeb = deDateb[1].split(':');
            deDateb = deDateb[0].split('.');
            if (typeof deTimeb[2] !== 'undefined') {
                y =
                    (deDateb[2] +
                        deDateb[1] +
                        deDateb[0] +
                        deTimeb[0] +
                        deTimeb[1] +
                        deTimeb[2]) *
                    1;
            } else {
                y =
                    (deDateb[2] +
                        deDateb[1] +
                        deDateb[0] +
                        deTimeb[0] +
                        deTimeb[1]) *
                    1;
            }
        } else {
            y = -Infinity;
        }
        const z = x < y ? -1 : x > y ? 1 : 0;
        return z;
    },

    'datetime-desc': function(a, b) {
        let x, y;
        if ($.trim(a) !== '') {
            const deDatea = $.trim(a).split(' ');
            const deTimea = deDatea[1].split(':');
            const deDatea2 = deDatea[0].split('.');
            if (typeof deTimea[2] !== 'undefined') {
                x =
                    (deDatea2[2] +
                        deDatea2[1] +
                        deDatea2[0] +
                        deTimea[0] +
                        deTimea[1] +
                        deTimea[2]) *
                    1;
            } else {
                x =
                    (deDatea2[2] +
                        deDatea2[1] +
                        deDatea2[0] +
                        deTimea[0] +
                        deTimea[1]) *
                    1;
            }
        } else {
            x = Infinity;
        }

        if ($.trim(b) !== '') {
            let deDateb = $.trim(b).split(' ');
            const deTimeb = deDateb[1].split(':');
            deDateb = deDateb[0].split('.');
            if (typeof deTimeb[2] !== 'undefined') {
                y =
                    (deDateb[2] +
                        deDateb[1] +
                        deDateb[0] +
                        deTimeb[0] +
                        deTimeb[1] +
                        deTimeb[2]) *
                    1;
            } else {
                y =
                    (deDateb[2] +
                        deDateb[1] +
                        deDateb[0] +
                        deTimeb[0] +
                        deTimeb[1]) *
                    1;
            }
        } else {
            y = -Infinity;
        }
        const z = x < y ? 1 : x > y ? -1 : 0;
        return z;
    },

    'date-asc': function(a, b) {
        let x, y;
        if ($.trim(a) !== '') {
            const deDatea = $.trim(a).split('.');
            x = (deDatea[2] + deDatea[1] + deDatea[0]) * 1;
        } else {
            x = Infinity; // = l'an 1000 ...
        }

        if ($.trim(b) !== '') {
            const deDateb = $.trim(b).split('.');
            y = (deDateb[2] + deDateb[1] + deDateb[0]) * 1;
        } else {
            y = -Infinity;
        }
        const z = x < y ? -1 : x > y ? 1 : 0;
        return z;
    },

    'date-desc': function(a, b) {
        let x, y;
        if ($.trim(a) !== '') {
            const deDatea = $.trim(a).split('.');
            x = (deDatea[2] + deDatea[1] + deDatea[0]) * 1;
        } else {
            x = -Infinity;
        }

        if ($.trim(b) !== '') {
            const deDateb = $.trim(b).split('.');
            y = (deDateb[2] + deDateb[1] + deDateb[0]) * 1;
        } else {
            y = Infinity;
        }
        const z = x < y ? 1 : x > y ? -1 : 0;
        return z;
    },
    'float-asc': function(a, b) {
        let x = a === '-' ? 0 : a.replace(/,/, '.');
        let y = b === '-' ? 0 : b.replace(/,/, '.');
        x = parseFloat(x);
        y = parseFloat(y);

        const z = x < y ? -1 : x > y ? 1 : 0;
        return z;
    },
    'float-desc': function(a, b) {
        let x = a === '-' ? 0 : a.replace(/,/, '.');
        let y = b === '-' ? 0 : b.replace(/,/, '.');
        x = parseFloat(x);
        y = parseFloat(y);
        const z = x < y ? 1 : x > y ? -1 : 0;
        return z;
    }
});



// WEBPACK FOOTER //
// ./src/components/DataTable/datatable-sorting.js